// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/js/common/components/ScoreCard/ScoreCard.css
// module id = 2024
// module chunks = 0